import { render, staticRenderFns } from "./PageDNEView.vue?vue&type=template&id=6aa7fa56&scoped=true&"
import script from "./PageDNEView.vue?vue&type=script&lang=ts&"
export * from "./PageDNEView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa7fa56",
  null
  
)

export default component.exports